<script setup>
import { computed } from 'vue'
import { useBreakpoint } from '@/composables/useBreakpoint'
import UiButton from '@/Components/UI/UiButton.vue'
import UiMenu from '@/Components/UI/UiMenu.vue'
import UiMenuItem from '@/Components/UI/UiMenuItem.vue'
import Icon from '@/Components/UI/Icon.vue'

const props = defineProps({
  // [{ key, label, icon, variant?, onClick, disabled?, primary? }]
  actions: { type: Array, required: true },
})

const { isDesktop, isMobile } = useBreakpoint()

const visibleActions = computed(() => {
  if (isDesktop.value) return props.actions
  if (isMobile.value) return props.actions.filter(a => a.primary)
  // Tablet: all actions but icon-only
  return props.actions
})

const overflowActions = computed(() => {
  if (!isMobile.value) return []
  return props.actions.filter(a => !a.primary)
})

const mode = computed(() => isDesktop.value ? 'full' : isMobile.value ? 'mobile' : 'icon')
</script>

<template>
  <div class="inline-flex items-center gap-2">
    <UiButton
      v-for="a in visibleActions"
      :key="a.key"
      :variant="a.variant || 'secondary'"
      size="sm"
      :icon-left="mode === 'full' ? a.icon : null"
      :class="mode === 'icon' ? 'icon-only !px-2' : ''"
      :disabled="a.disabled"
      :title="mode === 'icon' ? a.label : undefined"
      :aria-label="mode === 'icon' ? a.label : undefined"
      @click="a.onClick"
    >
      <Icon v-if="mode === 'icon'" :name="a.icon" :size="16" />
      <template v-else>{{ a.label }}</template>
    </UiButton>

    <UiMenu v-if="overflowActions.length">
      <template #trigger="{ toggle }">
        <button
          type="button"
          class="topbar-btn icon-only"
          :aria-label="$t('common.moreActions')"
          @click="toggle"
        >
          <Icon name="menu" :size="18" />
        </button>
      </template>
      <UiMenuItem
        v-for="a in overflowActions"
        :key="a.key"
        :disabled="a.disabled"
        @click="a.onClick"
      >
        <span class="inline-flex items-center gap-2">
          <Icon :name="a.icon" :size="16" />
          <span>{{ a.label }}</span>
        </span>
      </UiMenuItem>
    </UiMenu>
  </div>
</template>
